import React from 'react';
import styled from '@emotion/styled';
import { useMedia } from 'react-use';
import { breakpoints, spacing, Typography } from '@playdapp/ui';

import { getBreakpointQuery } from 'lib/util';

import Image from '@/components/Image';

type Props = {
  text?: string;
  children?: React.ReactNode;
};

const EmmptyItemBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  span {
    margin-top: ${spacing.xl};
  }
`;

const EmptyItem = ({ text = 'Sorry, No item found', children }: Props) => {
  const isMdDownScreen = useMedia(getBreakpointQuery(breakpoints.down('md')));
  return (
    <EmmptyItemBlock>
      <Image
        prefix="local"
        src="/folder.png"
        alt="empty"
        width={isMdDownScreen ? 117 : 146}
        height={isMdDownScreen ? 80 : 100}
      />
      <Typography type={isMdDownScreen ? 'h5' : 'h3'}>{text}</Typography>
      {children}
    </EmmptyItemBlock>
  );
};

export default EmptyItem;
